/*
Font Awesome Free License
-------------------------

Font Awesome Free is free, open source, and GPL friendly. You can use it for
commercial projects, open source projects, or really almost whatever you want.
Full Font Awesome Free license: https://fontawesome.com/license/free.

# Icons: CC BY 4.0 License (https://creativecommons.org/licenses/by/4.0/)
In the Font Awesome Free download, the CC BY 4.0 license applies to all icons
packaged as SVG and JS file types.

# Fonts: SIL OFL 1.1 License (https://scripts.sil.org/OFL)
In the Font Awesome Free download, the SIL OFL license applies to all icons
packaged as web and desktop font files.

# Code: MIT License (https://opensource.org/licenses/MIT)
In the Font Awesome Free download, the MIT license applies to all non-font and
non-icon files.

# Attribution
Attribution is required by MIT, SIL OFL, and CC BY licenses. Downloaded Font
Awesome Free files already contain embedded comments with sufficient
attribution, so you shouldn't need to do anything additional when using these
files normally.

We've kept attribution comments terse, so we ask that you do not actively work
to remove them from files, especially code. They're a great way for folks to
learn about Font Awesome.

# Brand Icons
All brand icons are trademarks of their respective owners. The use of these
trademarks does not indicate endorsement of the trademark holder by Font
Awesome, nor vice versa. **Please do not use brand logos for any purpose except
to represent the company, product, or service to which they refer.**
*/
package com.bikompanion.ui.icons

import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.SolidColor
import androidx.compose.ui.graphics.vector.ImageVector
import androidx.compose.ui.graphics.vector.path
import androidx.compose.ui.unit.dp

val FontAwesomeBuilding: ImageVector
    get() {
        if (_FontAwesomeBuilding != null) return _FontAwesomeBuilding!!

        _FontAwesomeBuilding = ImageVector
            .Builder(
                name = "building",
                defaultWidth = 24.dp,
                defaultHeight = 24.dp,
                viewportWidth = 448f,
                viewportHeight = 512f,
            ).apply {
                path(
                    fill = SolidColor(Color.Black),
                ) {
                    moveTo(436f, 480f)
                    horizontalLineToRelative(-20f)
                    verticalLineTo(24f)
                    curveToRelative(0f, -13.255f, -10.745f, -24f, -24f, -24f)
                    horizontalLineTo(56f)
                    curveTo(42.745f, 0f, 32f, 10.745f, 32f, 24f)
                    verticalLineToRelative(456f)
                    horizontalLineTo(12f)
                    curveToRelative(-6.627f, 0f, -12f, 5.373f, -12f, 12f)
                    verticalLineToRelative(20f)
                    horizontalLineToRelative(448f)
                    verticalLineToRelative(-20f)
                    curveToRelative(0f, -6.627f, -5.373f, -12f, -12f, -12f)
                    close()
                    moveTo(128f, 76f)
                    curveToRelative(0f, -6.627f, 5.373f, -12f, 12f, -12f)
                    horizontalLineToRelative(40f)
                    curveToRelative(6.627f, 0f, 12f, 5.373f, 12f, 12f)
                    verticalLineToRelative(40f)
                    curveToRelative(0f, 6.627f, -5.373f, 12f, -12f, 12f)
                    horizontalLineToRelative(-40f)
                    curveToRelative(-6.627f, 0f, -12f, -5.373f, -12f, -12f)
                    verticalLineTo(76f)
                    close()
                    moveToRelative(0f, 96f)
                    curveToRelative(0f, -6.627f, 5.373f, -12f, 12f, -12f)
                    horizontalLineToRelative(40f)
                    curveToRelative(6.627f, 0f, 12f, 5.373f, 12f, 12f)
                    verticalLineToRelative(40f)
                    curveToRelative(0f, 6.627f, -5.373f, 12f, -12f, 12f)
                    horizontalLineToRelative(-40f)
                    curveToRelative(-6.627f, 0f, -12f, -5.373f, -12f, -12f)
                    verticalLineToRelative(-40f)
                    close()
                    moveToRelative(52f, 148f)
                    horizontalLineToRelative(-40f)
                    curveToRelative(-6.627f, 0f, -12f, -5.373f, -12f, -12f)
                    verticalLineToRelative(-40f)
                    curveToRelative(0f, -6.627f, 5.373f, -12f, 12f, -12f)
                    horizontalLineToRelative(40f)
                    curveToRelative(6.627f, 0f, 12f, 5.373f, 12f, 12f)
                    verticalLineToRelative(40f)
                    curveToRelative(0f, 6.627f, -5.373f, 12f, -12f, 12f)
                    close()
                    moveToRelative(76f, 160f)
                    horizontalLineToRelative(-64f)
                    verticalLineToRelative(-84f)
                    curveToRelative(0f, -6.627f, 5.373f, -12f, 12f, -12f)
                    horizontalLineToRelative(40f)
                    curveToRelative(6.627f, 0f, 12f, 5.373f, 12f, 12f)
                    verticalLineToRelative(84f)
                    close()
                    moveToRelative(64f, -172f)
                    curveToRelative(0f, 6.627f, -5.373f, 12f, -12f, 12f)
                    horizontalLineToRelative(-40f)
                    curveToRelative(-6.627f, 0f, -12f, -5.373f, -12f, -12f)
                    verticalLineToRelative(-40f)
                    curveToRelative(0f, -6.627f, 5.373f, -12f, 12f, -12f)
                    horizontalLineToRelative(40f)
                    curveToRelative(6.627f, 0f, 12f, 5.373f, 12f, 12f)
                    verticalLineToRelative(40f)
                    close()
                    moveToRelative(0f, -96f)
                    curveToRelative(0f, 6.627f, -5.373f, 12f, -12f, 12f)
                    horizontalLineToRelative(-40f)
                    curveToRelative(-6.627f, 0f, -12f, -5.373f, -12f, -12f)
                    verticalLineToRelative(-40f)
                    curveToRelative(0f, -6.627f, 5.373f, -12f, 12f, -12f)
                    horizontalLineToRelative(40f)
                    curveToRelative(6.627f, 0f, 12f, 5.373f, 12f, 12f)
                    verticalLineToRelative(40f)
                    close()
                    moveToRelative(0f, -96f)
                    curveToRelative(0f, 6.627f, -5.373f, 12f, -12f, 12f)
                    horizontalLineToRelative(-40f)
                    curveToRelative(-6.627f, 0f, -12f, -5.373f, -12f, -12f)
                    verticalLineTo(76f)
                    curveToRelative(0f, -6.627f, 5.373f, -12f, 12f, -12f)
                    horizontalLineToRelative(40f)
                    curveToRelative(6.627f, 0f, 12f, 5.373f, 12f, 12f)
                    verticalLineToRelative(40f)
                    close()
                }
            }.build()

        return _FontAwesomeBuilding!!
    }

private var _FontAwesomeBuilding: ImageVector? = null
